import { NavLink } from "react-router-dom";
import styled from "styled-components";
import appConfig from "../config/appConfig";

const Bar = styled.header`
  background: var(--color-primary);
  color: #fff;
  border-bottom: 4px solid var(--color-accent);
`;

const Inner = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 1rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const Brand = styled(NavLink)`
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

const Logo = styled.img`
  height: 2.25rem;
  width: auto;
  border-radius: 4px;
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  a {
    color: #fff;
    text-decoration: none;
    font-weight: 500;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
  }
  a.active {
    background: rgba(255, 255, 255, 0.15);
  }
  a:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

function Header() {
  return (
    <Bar>
      <Inner>
        <Brand exact to={appConfig.paths.home}>
          <Logo src="/images/logo.webp" alt="Western PA Paramotors logo" />
          {appConfig.clubName}
        </Brand>
        <Nav>
          <NavLink exact to={appConfig.paths.home} activeClassName="active">
            Home
          </NavLink>
          <NavLink to={appConfig.paths.flyIn} activeClassName="active">
            Fly-In
          </NavLink>
          <NavLink to={appConfig.paths.memorial} activeClassName="active">
            Memorial
          </NavLink>
          <NavLink to={appConfig.paths.contact} activeClassName="active">
            Contact
          </NavLink>
        </Nav>
      </Inner>
    </Bar>
  );
}

export default Header;
